import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsPlanEntryRelatedCargoTaxiResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export enum BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsPlanEntryRelatedCargoTaxiResponseDataContractCargoCompany =
  {
    displayName: string;
  };

export type BillingsPlanEntryRelatedCargoTaxiResponseDataContract = {
  model: BillingsPlanEntryRelatedCargoTaxiResponseDataContractBillingModel;
  distanceRate: number;
  cargoCompany: BillingsPlanEntryRelatedCargoTaxiResponseDataContractCargoCompany;
};

export type BillingsPlanEntryRelatedCargoTaxiResponseDataCargoOrder = {
  id: string;
  humanId: number;
};

export type BillingsPlanEntryRelatedCargoTaxiResponseData = {
  id: string;
  draft: boolean;
  distance: number;
  amountForChargeHighways: number | null;
  amountForChargeHaltings: number | null;
  allContributionsAmount: number | null;
  amountForDistance: number | null;
  date: Date;
  cargoOrder: BillingsPlanEntryRelatedCargoTaxiResponseDataCargoOrder | null;
  contract: BillingsPlanEntryRelatedCargoTaxiResponseDataContract;
  contractCorrectionPercentage: number | null;
  sumOfDiscounts: number | null;
  status: BillingsPlanEntryRelatedCargoTaxiResponseDataBillingStatus;
};

type BillingsPlanEntryRelatedCargoTaxiResponse = HttpResponse<
  BillingsPlanEntryRelatedCargoTaxiResponseData[]
>;

export default BillingsPlanEntryRelatedCargoTaxiResponse;
